﻿import "../crypto/extensions";
import { isDomainTextValid } from '../utils/domainHelper';
import * as certificates from '../crypto/certificates';
import { buildFetchUrl } from "../utils/toolHelper";

interface CertificateResult { certificate: string, chain: string, thumbprint: string }
interface DnsServerResult { server: string, ip: string, values: string[], error: string, success: boolean }
interface CnameCheckResult { isConfigured: boolean, status: string, actualCnameTarget: string, conflictingTxtValues: string[], dnsServers: DnsServerResult[] }

var DOMAIN_TO_ISSUE_QUERY_PARAM = "domainToIssue";
var domainToIssue: string;
var domainToCname: string;
var privateKey: string;
var email: string;
var certificateResult: CertificateResult;
var domainContainer = document.getElementById("domain-container") as HTMLDivElement;
var cnameContainer = document.getElementById("cname-container") as HTMLDivElement;
var certContainer = document.getElementById("cert-container") as HTMLDivElement;
var errorContainer = document.getElementById("error-container") as HTMLDivElement;
var certIssuing = document.getElementById("cert-issuing") as HTMLDivElement;
var certEmail = document.getElementById("cert-email") as HTMLDivElement;
var certIssued = document.getElementById("cert-issued") as HTMLDivElement;
var checkProgress = document.getElementById("check-progress") as HTMLDivElement;
var domainIssued = document.getElementById("domain-issued") as HTMLHeadingElement;
var domainText = document.getElementById("domain-text") as HTMLInputElement;
var emailText = document.getElementById("email-text") as HTMLInputElement;
var generateButton = document.getElementById("generate-cert") as HTMLButtonElement;
var issueCertButton = document.getElementById("issue-cert") as HTMLButtonElement;
var downloadPrivateKeyButton = document.getElementById("download-key") as HTMLButtonElement;
var downloadCertificateButton = document.getElementById("download-cert") as HTMLButtonElement;
var iDidThisButton = document.querySelector(".i-did-this") as HTMLButtonElement;

var privateKeyText = document.getElementById("private-key-text") as HTMLTextAreaElement;
var certText = document.getElementById("certificate-text") as HTMLTextAreaElement;
var lastChecked = document.getElementById("last-checked") as HTMLParagraphElement;
var lastStatus = document.getElementById("last-status") as HTMLDivElement;
var dnsDiagnostics = document.getElementById("dns-diagnostics") as HTMLDetailsElement;
var dnsDiagnosticsTable = document.getElementById("dns-diagnostics-table") as HTMLDivElement;
var errorMessage = document.getElementById("error-message") as HTMLElement;

domainText.addEventListener("keyup", (evt) => {
    if (isDomainTextValid(domainText.value)) {
        generateButton.disabled = false;
        if (evt.keyCode == 13) {
            generateButtonClicked();
        }
    }
    else {
        generateButton.disabled = true;
    }
});

var generateButtonClicked = async () => {
    domainToIssue = domainText.value as string;
    if (!domainToIssue.startsWith("*.")) {
        domainToIssue = "*." + domainToIssue;
    }

    try {

        await getChallengeGuid();

        await cnameSetup();

        await pollForCname();

        email = await getEmail();

        certificateResult = await generateCsrAndIssueCert();
    }
    catch (ex) {
        errorContainer.style.display = "block";
        errorMessage.innerText = ex instanceof Error ? ex.message : ex.toString();
    }
}

generateButton.addEventListener("click", generateButtonClicked)


async function getChallengeGuid() {
    var response = await fetch(buildFetchUrl("?handler=BeginCertificate"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            domain: domainToIssue
        })
    });

    var json = await response.json();

    if (json.error) {
        throw new Error(json.error);
    }

    domainContainer.style.display = "none";
    cnameContainer.style.display = "block";

    domainToCname = json.acmeChallengeDomain;
    document.getElementById("domain-to-cname").innerText = domainToCname;

    try {
        const url = new URL(window.location.toString());
        url.searchParams.set(DOMAIN_TO_ISSUE_QUERY_PARAM, domainToIssue);
        history.replaceState(null, "", url);
    }
    catch { }

    document.getElementById("cname-destination").innerText = json.certkitCnameTarget;

    return domainToCname;
}


async function cnameSetup(): Promise<void> {
    const deferred = (() => {
        let resolve, reject;
        const promise = new Promise<void>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    })();

    iDidThisButton.addEventListener("click", () => {
        deferred.resolve();
    });


    return deferred.promise;
}

async function pollForCname() {

    iDidThisButton.style.display = "none";
    checkProgress.style.display = "block";

    var doPoll = async (): Promise<CnameCheckResult> => {
        var response = await fetch(buildFetchUrl("?handler=CheckCname"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                domain: domainToIssue
            })
        })

        var json = await response.json();

        return json;
    }

    var isConfigured = false;
    var timesChecked = 1;
    do {
        await new Promise(r => setTimeout(r, 5000));
        var result = await doPoll();
        isConfigured = result.isConfigured;
        lastChecked.innerHTML = "Last Checked: " + new Date().toLocaleTimeString() + ` (Checked ${timesChecked.toLocaleString()} times)`
        showCnameStatus(result);
        // The first couple of checks usually just catch DNS mid-propagation.
        if (timesChecked > 2) {
            showDnsDiagnostics(result.dnsServers);
        }
        timesChecked++;
        console.log("CNAME", isConfigured);
    }
    while (isConfigured == false);


    return;
}

// Same wording as the certificate page in the app.
function showCnameStatus(result: CnameCheckResult) {
    lastStatus.innerHTML = "";

    if (result.status == "CnameMissing") {
        lastStatus.append(statusText("No CNAME record found yet... "), document.createElement("br"), propagationNote());
    }
    else if (result.status == "CnameMisconfigured") {
        var misconfigured = statusText("CNAME is pointed incorrectly to ");
        misconfigured.append(highlight(result.actualCnameTarget));
        lastStatus.append(misconfigured, document.createElement("br"), propagationNote());
    }
    else if (result.status == "ConflictingTxtRecords") {
        var conflict = document.createElement("div");
        conflict.className = "certificate-status ok";
        conflict.append("Conflicting ", highlight("TXT"), " records exist at ", highlight(domainToCname));
        conflict.append(document.createElement("br"), document.createElement("br"), "Values:");
        for (var value of result.conflictingTxtValues) {
            var valueRow = document.createElement("div");
            valueRow.append(highlight(value));
            conflict.append(valueRow);
        }
        conflict.append(document.createElement("br"), "Please remove these records.");
        lastStatus.append(conflict);
    }
}

function statusText(text: string): HTMLElement {
    var status = document.createElement("small");
    status.className = "certificate-status ok";
    status.textContent = text;
    return status;
}

function propagationNote(): HTMLElement {
    var note = document.createElement("small");
    note.className = "pico-color-grey-500";
    note.textContent = "(DNS changes can take up to a minute to propagate.)";
    return note;
}

function highlight(text: string): HTMLElement {
    var span = document.createElement("span");
    span.className = "pico-color-amber-600";
    span.textContent = text;
    return span;
}

// dnsServers is only sent when the new DNS checker ran (Shadow or NewChecker mode).
function showDnsDiagnostics(dnsServers: DnsServerResult[]) {
    if (!dnsServers) {
        dnsDiagnostics.style.display = "none";
        return;
    }

    var table = document.createElement("table");
    var headerRow = table.createTHead().insertRow();
    for (var heading of ["DNS Server", "IP", "Values", "Error"]) {
        var th = document.createElement("th");
        th.textContent = heading;
        headerRow.append(th);
    }

    var body = table.createTBody();
    for (var dnsServer of dnsServers) {
        var row = body.insertRow();
        row.className = dnsServer.error ? "diag-error" : (dnsServer.success ? "" : "diag-warning");
        for (var cellText of [dnsServer.server, dnsServer.ip, dnsServer.values.join(", "), dnsServer.error ?? ""]) {
            row.insertCell().textContent = cellText;
        }
    }

    dnsDiagnosticsTable.innerHTML = "";
    dnsDiagnosticsTable.append(table);
    dnsDiagnostics.style.display = "block";
}

async function issueCertificate(domainToIssue: string, stuff: { csr: string; publicKey: string; privateKey: string; }): Promise<CertificateResult> {
    try {
        const url = new URL(window.location.toString());
        url.searchParams.delete(DOMAIN_TO_ISSUE_QUERY_PARAM)
        history.replaceState(null, "", url);
    }
    catch { }

    privateKey = stuff.privateKey;

    var response = await fetch(buildFetchUrl("?handler=IssueCertificate"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            domain: domainToIssue,
            csr: stuff.csr,
            email: email
        }),
    })

    if (response.status != 200) {
        throw new Error(await response.text());
    }

    var json = await response.json();

    return json;
}

async function getEmail(): Promise<string> {
    cnameContainer.style.display = "none";
    certEmail.style.display = "block";
    const deferred = (() => {
        let resolve, reject;
        const promise = new Promise<string>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    })();

    emailText.addEventListener("keyup", (evt) => {
        var isValid = emailText.checkValidity()
        issueCertButton.disabled = !isValid;
        if (evt.keyCode == 13 && isValid) {
            deferred.resolve(emailText.value);
        }
    });

    issueCertButton.addEventListener("click", () => {
        deferred.resolve(emailText.value);
    })

    return deferred.promise;
}


async function generateCsrAndIssueCert() {
    certContainer.style.display = "block";
    certIssuing.style.display = "block";
    certEmail.style.display = "none";

    var csrData = await certificates.generateCsr(domainToIssue);

    var certificateResult = await issueCertificate(domainToIssue, csrData);

    certIssuing.style.display = "none";
    certIssued.style.display = "block";

    domainIssued.innerText = domainToIssue;
    privateKeyText.value = privateKey;
    certText.value = certificateResult.certificate + "\n" + certificateResult.chain;

    return certificateResult;
}

downloadCertificateButton.addEventListener("click", () => {
    var text = certificateResult.certificate + "\n" + certificateResult.chain;
    var file = new File([text], "certificate.pem");
    var downloadUrl = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'certificate.pem'; // The desired filename for the JS file

    document.body.appendChild(link); // Append to DOM to make it clickable
    link.click(); // Programmatically click the link to trigger download
    setTimeout(() => {
        document.body.removeChild(link); // Clean up the DOM
        URL.revokeObjectURL(downloadUrl); // Release the object URL
    }, 100);
})

downloadPrivateKeyButton.addEventListener("click", () => {
    var text = privateKey;
    var file = new File([text], "private.key");
    var downloadUrl = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = "private.key"; // The desired filename for the JS file

    document.body.appendChild(link); // Append to DOM to make it clickable
    link.click(); // Programmatically click the link to trigger download
    setTimeout(() => {
        document.body.removeChild(link); // Clean up the DOM
        URL.revokeObjectURL(downloadUrl); // Release the object URL
    }, 100);
})
///

function animateLoading() {
    const frames = ['-', '\\', '|', '/'];
    var loadingElements = document.querySelectorAll<HTMLDivElement>(".loading");

    loadingElements.forEach(el => {
        let i = 0;
        const spinner = setInterval(() => {
            el.innerText = frames[i = ++i % frames.length];
        }, 125);
    })
}

try {
    const url = new URL(window.location.toString());
    var prevDomain = url.searchParams.get(DOMAIN_TO_ISSUE_QUERY_PARAM);
    if (prevDomain) {
        domainText.value = prevDomain;
        generateButtonClicked();
    }
}
catch { }

animateLoading();